// extracted by mini-css-extract-plugin
export default {"container":"PermissionsOverview_container__sQUXO","cards_container":"PermissionsOverview_cards_container__bIDlh","loader_container":"PermissionsOverview_loader_container__4rFul"};